import FilterButton from '@admin-components/FilterButton';
import InviteUserModal from '@admin-components/InviteUserModal';
import SettingsButton from '@admin-components/SettingsButton';
import { ROUTES } from '@const';
import AddOutlined from '@icons/AddOutlined';
import ArrowDropDownFilled from '@icons/ArrowDropDownFilled';
import SearchOutlined from '@icons/SearchOutlined';
import { Box, Button, ButtonGroup, InputAdornment, Tab, Tabs, TextField, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import UserTable from './Tables/UserTable';

const AdminView = () => {
  const navigate = useNavigate();
  const [inviteModalOpen, setInviteModalOpen] = useState(false);

  const onTabChanged = useCallback(
    (_: React.SyntheticEvent, newValue: string) => {
      navigate(`/admin/${newValue}`);
    },
    [navigate]
  );

  const onInviteUser = useCallback(() => {
    setInviteModalOpen(true);
  }, []);

  const onCloseInviteModal = useCallback(() => {
    setInviteModalOpen(false);
  }, []);

  // extract the current tab from the location
  const location = useLocation();
  const pathParts = location.pathname.split('/');
  const activeTab = pathParts.length > 2 ? pathParts[2] : 'users';

  // if we are missing the pathname, add it
  useEffect(() => {
    if (pathParts.length <= 2) {
      navigate(ROUTES.ADMIN_USERS, { replace: true });
    }
  }, [navigate, pathParts]);

  return (
    <>
      <InviteUserModal open={inviteModalOpen} onClose={onCloseInviteModal} />
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          pt: 2,
          pr: 2,
          pl: 2,
          gap: 2
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Typography variant="h5" sx={{ flex: 1 }}>
            Admin
          </Typography>
          <TextField
            sx={{ width: 400 }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchOutlined />
                  </InputAdornment>
                )
              }
            }}
            variant="outlined"
            size="small"
            placeholder="Search"
          />
          <ButtonGroup variant="contained">
            <Button sx={{ color: 'white', gap: 1 }} variant="contained" onClick={onInviteUser}>
              <AddOutlined />
              Invite User
            </Button>
            <Button sx={{ color: 'white' }} variant="contained">
              <ArrowDropDownFilled />
            </Button>
          </ButtonGroup>
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'row'
            }}
          >
            <FilterButton />
            <SettingsButton />
          </Box>
        </Box>
        <Tabs value={activeTab} onChange={onTabChanged}>
          <Tab value="users" label="Users" />
          <Tab value="groups" label="Groups" />
          <Tab value="campaigns" label="Campaigns" />
        </Tabs>
        <Box
          sx={{
            display: 'flex',
            height: '100%',
            flex: 1
          }}
        >
          {activeTab === 'users' && <UserTable />}
        </Box>
      </Box>
    </>
  );
};
export default AdminView;
